<template>
    <el-dialog class="el-dialogs" :title="title" :fullscreen="true" :close-on-click-modal="false"
               :visible.sync="visible">
        <el-form size="small" ref="searchForm" :model="searchForm" :rules="rules"
                 label-width="110px">
            <div class="dialogPadding">
                <div class="flex_l_t flexWarp">
                    <el-form-item label="借阅单号" prop="orderNum">
                        <div>{{ searchForm.applicationOdd }}</div>
                    </el-form-item>
                    <el-form-item label="借阅人" prop="createByName">
                        <div>{{ searchForm.createByName }}</div>
                    </el-form-item>
                    <el-form-item label="借阅目的" prop="purpose">
                        <el-select v-if="typeName == 'edit'" style="width: 100%" v-model="searchForm.purpose"
                                   clearable
                                   placeholder="请选择借阅目的">
                            <el-option
                                    v-for="item in $dictUtils.getDictList('purpose_type')"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                            </el-option>
                        </el-select>
                        <div v-else>{{ $dictUtils.getDictLabel("purpose_type", searchForm.purpose, '') }}</div>
                    </el-form-item>
                    <el-form-item label="借阅内容" prop="applicationContent">
                        <el-checkbox-group v-model="searchForm.applicationContent" :disabled="typeName != 'edit'">
                            <el-checkbox :label="'0'">脱敏字段</el-checkbox>
                            <el-checkbox :label="'1'">在线预览</el-checkbox>
                            <el-checkbox :label="'2'">文件下载</el-checkbox>
                        </el-checkbox-group>
                    </el-form-item>
                    <el-form-item label="借阅开始时间" prop="applicationDate">
                        <el-date-picker v-if="typeName == 'edit'" v-model="searchForm.applicationDate"
                                        type="date" value-format="yyyy-MM-dd"
                                        style="width: 100%;" clearable
                                        :picker-options="pickerOptions"
                                        placeholder="选择日期">
                        </el-date-picker>
                        <div v-else>{{ searchForm.applicationDate }}</div>
                    </el-form-item>
                    <el-form-item label="借阅天数(天)" prop="applicationDay">
                        <el-input v-if="typeName == 'edit'" v-model.trim="searchForm.applicationDay" maxlength="3"
                                  placeholder="请输入借阅天数(1~999)" @input="setBorrowDays('applicationDay')"
                                  clearable></el-input>
                        <div v-else>{{ searchForm.applicationDay }}</div>
                    </el-form-item>
                    <el-form-item label="借阅状态" prop="applicationState">
                        <div>{{ $dictUtils.getDictLabel("application_state", searchForm.applicationState, '') }}</div>
                    </el-form-item>
                    <el-form-item label="审核人" prop="auditByName"
                                  v-if="searchForm.applicationState == 4 || searchForm.applicationState == 2 || searchForm.applicationState == 3">
                        <div>{{ searchForm.auditByName }}</div>
                    </el-form-item>
                    <el-form-item label="审核建议" prop="processOpinion"
                                  v-if="typeName == 'toExamineView' && searchForm.applicationState != 1">
                        <div>{{ searchForm.processOpinion }}</div>
                    </el-form-item>
                    <el-form-item label="审核时间" prop="createDate"
                                  v-if="searchForm.applicationState == 4 || searchForm.applicationState == 2 || searchForm.applicationState == 3">
                        <div>{{ searchForm.createDate }}</div>
                    </el-form-item>
                    <!--                    <el-form-item label="申请人" prop="createBy" v-if="typeName == 'toExamineView'">-->
                    <!--                        <div>{{ searchForm.createBy }}</div>-->
                    <!--                    </el-form-item>-->
                    <el-form-item label="申请时间" prop="submitTime"
                                  v-if="searchForm.applicationState == 4 || searchForm.applicationState == 2 || searchForm.applicationState == 3">
                        <div>{{ searchForm.submitTime }}</div>
                    </el-form-item>
                    <el-form-item v-if="typeName != 'edit'" label="备注说明" prop="remark">
                        <div>{{ searchForm.remark }}</div>
                    </el-form-item>
                    <el-form-item label="归还时间" prop="returnDate"
                                  v-if="searchForm.applicationState == 2 || searchForm.applicationState == 3 || searchForm.applicationState == 4">
                        <div>{{ searchForm.returnDate }}</div>
                    </el-form-item>
                </div>
            </div>
            <el-form-item v-if="typeName == 'edit'" label="备注说明" prop="remark" style="padding-right: 40%;">
                <el-input
                        type="textarea"
                        :rows="4" resize="none"
                        maxlength="200"
                        placeholder="请输入内容(限200字)"
                        v-model="searchForm.remark">
                </el-input>
            </el-form-item>
            <el-form-item label="借阅资源"></el-form-item>
            <div class="borrowing">
                <el-tabs v-model="seleMetadata" type="card" @tab-click="handleClick">
                    <el-tab-pane v-for="item in basicData" :label="item.basicDataName" :name="item.basicDataId"
                                 :key="item.basicDataId"></el-tab-pane>
                </el-tabs>
                <el-table
                        :data="dataList"
                        v-loading="loading"
                        size="small" height="250px"
                        class="table" ref="multipleTable" border>
                    <el-table-column prop="mingcheng" label="名称" show-overflow-tooltip>
                        <template slot-scope="scope">
                            <span>{{ scope.row.map.jsonData.mingcheng }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="zhuangtai" label="状态" show-overflow-tooltip>
                        <template slot-scope="scope">
                            <span>{{ scope.row.map.jsonData.zhuangtai }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="jiandingjieguo" label="鉴定结果" show-overflow-tooltip>
                        <template slot-scope="scope">
                            <span>{{ scope.row.map.jsonData.jiandingjieguo }}</span>
                        </template>
                    </el-table-column>
                    </el-table-column>
                    <el-table-column prop="chuangjianren" label="创建人" show-overflow-tooltip>
                        <template slot-scope="scope">
                            <span>{{ scope.row.map.jsonData.chuangjianren }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="chuangjianshijian" label="创建时间" show-overflow-tooltip>
                        <template slot-scope="scope">
                            <span>{{ scope.row.map.jsonData.chuangjianshijian }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="xiugairen" label="最新修改人" show-overflow-tooltip>
                        <template slot-scope="scope">
                            <span>{{ scope.row.map.jsonData.xiugairen }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="xiugaishijian" label="最新修改时间" show-overflow-tooltip>
                        <template slot-scope="scope">
                            <span>{{ scope.row.map.jsonData.xiugaishijian }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                            fixed="right"
                            label="操作">
                        <template slot-scope="scope">
                            <el-button type="text" size="small" @click="view(scope.row)">查看</el-button>
                            <el-button v-show="title == '修改资源借阅单'" type="text" size="small"
                                       @click="cancelBorrow(scope.row)">取消借阅
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </el-form>
        <div slot="footer" v-if="title == '修改资源借阅单'">
            <el-button size="small" @click="visible = false">取消</el-button>
            <el-button size="small" type="primary" @click="submit('save')" v-noMoreClick>保存</el-button>
            <el-button size="small" type="primary" @click="submit('submit')" v-noMoreClick>提交</el-button>
        </div>
        <div slot="footer" v-else-if="title == '资源借阅单审核详情'">
            <el-button size="small" @click="visible = false">关闭</el-button>
            <el-button size="small" type="primary" @click="setToexamine('through')" v-noMoreClick>通过</el-button>
            <el-button size="small" type="danger" @click="setToexamine('reject')" v-noMoreClick>驳回</el-button>
        </div>
        <div slot="footer" v-else>
            <el-button size="small" @click="visible = false">返回</el-button>
        </div>
        <set-toexamine ref="setToexamine" @refresh="toexamineRefresh()"></set-toexamine>
        <ResourceAddEditForm ref="resourceAddEditForm"></ResourceAddEditForm>
    </el-dialog>
</template>

<script>
import SetToexamine from "@/components/toExamine/setToexamine.vue";
import ResourceAddEditForm from "@/views/modules/dyygCollect/library/resourceAddEditForm.vue";

export default {
    name: "addBorrowing",
    components: {ResourceAddEditForm, SetToexamine},
    data() {
        return {
            title: '修改资源借阅单',
            typeName: '',
            visible: false,
            searchForm: {
                id: '',
                auditId: "",
                applicationOdd: '',
                createBy: '',
                purpose: '',
                applicationContent: [],
                applicationDate: '',
                applicationDay: '',
                applicationState: "",
                auditByName: '',
                processOpinion: '',
                createDate: '',
                submitTime: '',
                remark: '',
                returnDate: '',
            },
            rules: {
                purpose: [
                    {required: true, message: '请选择借阅目的', trigger: 'blur'}
                ],
                applicationContent: [
                    {type: 'array', required: true, message: '请选择借阅内容', trigger: 'change'}
                ],
                applicationDate: [
                    {required: true, message: '请选择借阅开始时间', trigger: 'change'}
                ],
                applicationDay: [
                    {required: true, message: '请填写借阅天数', trigger: 'blur'}
                ],
            },
            basicData: [],
            seleMetadata: '',
            dataList: [],
            loading: false,

            pickerOptions: {
                disabledDate(time) {
                    // 选择今天以及今天之后的日期
                    return time.getTime() < Date.now() - 8.64e7// 如果没有后面的-8.64e7就是不可以选择
                    // 选择今天以及今天之前的日期
                    // return time.getTime() > Date.now() - 8.64e7// 如果没有后面的-8.64e7就是不可以选择今天的
                }
            },

            selectData: {},
        }
    },

    methods: {
        //typeName view详情 edit编辑 toExamineView审核详情
        init(row, typeName) {
            if (typeName == 'view') {
                this.title = '资源借阅单详情'
            }
            if (typeName == 'edit') {
                this.title = '修改资源借阅单'
            }
            if (typeName == 'toExamineView') {
                this.title = '资源借阅单审核详情'
            }
            if (typeName == 'recordView') {
                this.title = '资源借阅单详情'
            }
            this.selectData = row
            this.typeName = typeName
            this.visible = true
            this.$nextTick(() => {
                this.$refs.searchForm.resetFields()
            })
            this.dataList = []
            this.getDetail(row)
        },

        getDetail(row) {
            this.$axios(this.api.academic.resourceapplicationGetById + row.id, {}).then(data => {
                if (data && data.status) {
                    Object.keys(this.searchForm).forEach(key => {
                        if (key == 'applicationContent') {
                            this.searchForm[key] = data.data[key].split(',')
                        } else {
                            this.searchForm[key] = data.data[key]
                        }
                    })
                }
            })
            this.$axios(this.api.academic.resourceapplicationGetBasicDataList, {
                applicationId: row.id,
            }).then(data => {
                if (data && data.status) {
                    this.basicData = data.data
                    this.seleMetadata = this.basicData[0].basicDataId
                    this.getDataList()
                }
            })
        },

        handleClick(tab, event) {
            this.getDataList()
        },

        getDataList() {
            this.loading = true
            this.$axios(this.api.academic.getResourceList, {
                applicationId: this.selectData.id,
                basicDataId: this.seleMetadata,
            }, 'get').then(data => {
                if (data && data.status) {
                    this.dataList = data.data
                    this.loading = false
                } else {
                    this.$message.error('查询失败')
                }
            })
        },

        //查看
        view(row) {
            this.$refs.resourceAddEditForm.init('view', row.map.id, '', row.map.basicDataId)
        },

        //取消借阅
        cancelBorrow(row) {
            this.$confirm(`您是否确认取消借阅该资源?`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$axios(this.api.academic.resourceapplicationCancelById, {id: row.id}, 'delete').then(data => {
                    if (data && data.status) {
                        this.$message.success('取消借阅成功')
                        this.getDataList()
                    } else {
                        this.$message.error(data.msg)
                    }
                })
            })
        },

        //type through通过 reject驳回
        setToexamine(type) {
            let url = this.api.academic.resourceapplicationAudit
            let ids = [this.searchForm.auditId]
            if (type == 'through') {
                let year = new Date().getFullYear();
                let month = new Date().getMonth() + 1;
                let day = new Date().getDate();
                let dataGoOver = this.toDateSize(year + '-' + month + '-' + day, this.searchForm.applicationDate)
                if (dataGoOver) {
                    this.$confirm(`借阅开始时间必须等于或大于当前时间！`, '提示', {
                        confirmButtonText: `驳回`,
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        //驳回
                        this.$refs.setToexamine.init(ids, 'reject', url, {
                            auditState: 4
                        })
                    })
                } else {
                    //通过
                    this.$refs.setToexamine.init(ids, 'through', url, {
                        auditState: 2
                    })
                }
            } else {
                //驳回
                this.$refs.setToexamine.init(ids, 'reject', url, {
                    auditState: 4
                })
            }
        },

        //通过驳回结束
        toexamineRefresh() {
            this.$emit('refresh')
            this.visible = false
        },


        //保存
        submit(type) {
            this.$refs.searchForm.validate((valid) => {
                if (valid) {
                    this.searchForm.applicationContent = this.searchForm.applicationContent.join(',')
                    if (type == 'submit') {
                        //提交 改状态
                        this.searchForm.applicationState = 1
                    } else {
                        this.searchForm.applicationState = 0
                    }
                    this.$axios(this.api.academic.resourceapplicationUpdateById, {
                        ...this.searchForm,
                    }, 'put').then(data => {
                        if (data && data.status) {
                            this.$message.success(`${type == 'save' ? '保存' : '提交'}成功`)
                            this.$emit('refresh')
                            this.visible = false
                        } else {
                            this.$message.error(data.msg)
                        }
                    })
                }
            });
        },

        //只能输入大于0的正整数
        setBorrowDays(formName) {
            this.searchForm[formName] = this.searchForm[formName].replace(/[^0-9]/g, "")
            if (this.searchForm[formName] == 0) {
                this.searchForm[formName] = ''
            }
        },

    },
}
</script>

<style lang="scss" scoped>
.dialogPadding {
  padding-right: 40%;

  .el-form-item {
    width: 48%;
    margin-left: 2%;
  }

  .flexWarp {
    flex-wrap: wrap;
  }
}

.borrowing {
  padding: 0 35px 0;
  margin-top: -10px;
}

</style>
